<template>
  <transition name="fade-out" mode="out-in">
    <div tabindex="-1" class="fp-preferences-container">
      <!-- First step -->
      <preferences-intro
        v-if="firstStep"
        :continueButtonClick="continueButtonClick"
      >
      </preferences-intro>

      <!-- Second step -->
      <preferences-payments
        v-if="secondStep"
        :backButtonClick="backButtonClick"
        @nextButtonClick="nextButtonClick"
      >
      </preferences-payments>

      <!-- Third step -->
      <preferences-calendar
        v-if="thirdStep"
        :backButtonClick="backButtonClick"
        :toWelcomeScreenBtn="toWelcomeScreenBtn"
      >
      </preferences-calendar>

      <!-- Fourth step -->
      <preferences-welcome
        v-if="fourthStep"
        :displayUserName="displayUserName"
      >
      </preferences-welcome>

      <div class="sub-nav-menu" v-if="!fourthStep">
        <user-info-menu :preferences="true"></user-info-menu>
      </div>
    </div>
  </transition>
</template>

<script>
  import PreferencesIntro from "./PreferencesIntro";
  import PreferencesPayments from "./PreferencesPayments";
  import PreferencesCalendar from "./PreferencesCalendar";
  import PreferencesWelcome from "./PreferencesWelcome";
  import UserInfoMenu from "../appLayout/UserInfoMenu";

  export default {
    name: "FPPreferences",
    components: {
      'preferences-intro': PreferencesIntro,
      'preferences-payments': PreferencesPayments,
      'preferences-calendar': PreferencesCalendar,
      'preferences-welcome': PreferencesWelcome,
      'user-info-menu': UserInfoMenu,
    },
    data() {
      return {
        firstStep: true,
        secondStep: false,
        thirdStep: false,
        fourthStep: false
      }
    },
    computed: {
      displayUserName() {
        return this.$store.getters.user.firstname + ' ' + this.$store.getters.user.lastname
      },
      paymentPreferenceCompleted() {
        return this.$store.getters.paymentPreferenceCompleted
      },
      parentingSchedulePreferenceCompleted() {
        return this.$store.getters.parentingSchedulePreferenceCompleted
      },
      hasCoparents() {
        return this.$store.getters.hasCoparents
      },
      hasRecordKeepingCoparents() {
        return this.$store.getters.hasRecordKeepingCoparents
      },
    },
    /**
     * @description Method sets needed preferences screen depending on completed params, that we got from API
     */
    mounted() {
      if (!this.paymentPreferenceCompleted && !this.parentingSchedulePreferenceCompleted) {
        this.firstStep = true;
        this.secondStep = false;
        this.thirdStep = false;
        this.fourthStep = false;
      } else if (this.paymentPreferenceCompleted && !this.parentingSchedulePreferenceCompleted) {
        this.firstStep = false;
        this.secondStep = false;
        this.thirdStep = true;
        this.fourthStep = false;
      } else if (this.paymentPreferenceCompleted && this.parentingSchedulePreferenceCompleted) {
        this.firstStep = false;
        this.secondStep = false;
        this.thirdStep = false;
        this.fourthStep = true;
      }
    },
    methods: {
      /**
       * @description Method switches welcome to payment preferences screen
       */
      continueButtonClick() {
        this.firstStep = false;
        this.secondStep = true;
      },
      /**
       * @description Method switches payment preferences to parenting schedule preferences screen
       */
      nextButtonClick() {
        this.secondStep = false;
        this.thirdStep = true;
      },
      /**
       * @description Method switches screen to the previous one, depending on current screen
       */
      backButtonClick() {
        if (this.secondStep) {
          this.secondStep = false;
          this.firstStep = true;
        } else {
          this.thirdStep = false;
          this.secondStep = true;
        }
      },
      /**
       * @description Take the user from finished preferences to Welcome screen
       */
      toWelcomeScreenBtn() {
        this.thirdStep = false;
        this.fourthStep = true;
      }
    }
  }
</script>

<style lang="scss">
  @import '@/scss/04_components/_preferences.scss';
</style>
